var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.412,
    height: 21.412,
    viewBox: "0 0 21.412 21.412",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\xEB\\xCE\\xD3\\xC8_1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33609",
    "data-name": "Group 33609",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33607",
    "data-name": "Group 33607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33604",
    "data-name": "Group 33604",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79885",
    "data-name": "Path 79885",
    d: "M10.706,21.412A10.709,10.709,0,0,1,3.134,3.134,10.709,10.709,0,0,1,18.278,18.278a10.637,10.637,0,0,1-7.572,3.134Zm0-20.969A10.265,10.265,0,0,0,3.447,17.965,10.265,10.265,0,0,0,17.965,3.447a10.2,10.2,0,0,0-7.259-3Z",
    transform: "translate(0 0)",
    fill: "#c13434"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33605",
    "data-name": "Group 33605",
    transform: "translate(1.46 1.46)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79886",
    "data-name": "Path 79886",
    d: "M26.446,35.692a9.241,9.241,0,1,1,6.539-2.707A9.186,9.186,0,0,1,26.446,35.692Zm0-18.064a8.813,8.813,0,1,0,6.237,2.581A8.762,8.762,0,0,0,26.446,17.628Z",
    transform: "translate(-17.2 -17.2)",
    fill: "#c13434"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33606",
    "data-name": "Group 33606",
    transform: "translate(2.986 2.986)",
    opacity: 0.69
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79887",
    "data-name": "Path 79887",
    d: "M42.891,50.611a7.717,7.717,0,1,1,5.46-2.26A7.669,7.669,0,0,1,42.891,50.611Zm0-14.626a6.9,6.9,0,1,0,4.884,2.021A6.859,6.859,0,0,0,42.891,35.985Z",
    transform: "translate(-35.17 -35.17)",
    fill: "#c13434"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_79888",
    "data-name": "Path 79888",
    d: "M70.041,62.857a5.082,5.082,0,1,0,1.487,3.592A5.047,5.047,0,0,0,70.041,62.857Z",
    transform: "translate(-55.743 -55.743)",
    fill: "#c13434"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/live.99e11550ba5a4eb4e6a203667e96fc93.svg";
export { ForwardRef as ReactComponent };